import React, { useState, useEffect } from "react";
import { Row, Col, Tab, Tabs, Form } from "react-bootstrap";
import { LegendField, LegendTextarea, IconField } from "../../components/fields";
import { Item, Anchor, Box, Button, Image } from "../../components/elements";
import { CardLayout, TabCard } from "../../components/cards";
import { Breadcrumb, FileUpload } from "../../components"; 
import PageLayout from "../../layouts/PageLayout";
import data from "../../data/master/myAccount.json";
import Spinner from 'react-bootstrap/Spinner'
import { Alert } from "react-bootstrap";
import api from "../../data/master/api.json";

export default function MyAccount() {
    
    const [alertMessage, setAlertMessage] = useState('');
    const [loading, setLoading] = useState(false);
    const [title, setTitle] = useState(localStorage.getItem("title"));

    const [oldPassword, setOldPassword] = useState('');
    const [password1, setPassword1] = useState('');
    const [password2, setPassword2] = useState('');

    const handleSubmit1 = (e) => {
        e.preventDefault();
        doProfileUpdate();
    }; 

    const handleSubmit2 = (e) => {
        e.preventDefault();
        doPasswordUpdate();
    }; 

    const doProfileUpdate = async () => {
        setLoading(true)
        setAlertMessage('');
        await fetch(api.base_url+api.update_user_profile, {
            method: 'POST',
            body: JSON.stringify({
                title: title            
            }),
            headers: {
                'Content-type': 'application/json; charset=UTF-8',
                'Authorization': 'bearer ' + localStorage.getItem('session_id'),
                "Access-Control-Allow-Origin": "*"
            },
        })
            .then((response) => response.json())
            .then((data) => {
                    setAlertMessage( data['message'] );
                    if ( data['status'] === 'success' ){
                        localStorage.setItem("title", title)
                    }
            })
            .catch((err) => {
                console.log(err.message);
            });
        setLoading(false)
    };

    const doPasswordUpdate = async () => {
        setLoading(true)
        setAlertMessage('');
        await fetch(api.base_url+api.update_user_password, {
            method: 'POST',
            body: JSON.stringify({
                old_password: oldPassword,
                password_1: password1,
                password_2: password2
            }),
            headers: {
                'Content-type': 'application/json; charset=UTF-8',
                'Authorization': 'bearer ' + localStorage.getItem('session_id'),
                "Access-Control-Allow-Origin": "*"
            },
        })
            .then((response) => response.json())
            .then((data) => {
                    setAlertMessage( data['message'] );
                    setOldPassword('');
                    setPassword1('');
                    setPassword2('');
            })
            .catch((err) => {
                console.log(err.message);
            });
        setLoading(false)
    };

    let valert;
    if (alertMessage !== '' ) {
        valert = <Alert key="abc123" variant="warning" onClose={() => setAlertMessage('')} dismissible>{alertMessage}</Alert>
    } else {
        valert = ""
    }

    return (
        <PageLayout>
            <Row>
                <Col xl={12}>
                    <Breadcrumb title={ data?.pageTitle }>
                        {data?.breadcrumb.map((item, index) => (
                            <Item key={ index } className="mc-breadcrumb-item">
                                {item.path ? <Anchor className="mc-breadcrumb-link" href={ item.path }>{ item.text }</Anchor> : item.text }
                            </Item>
                        ))}
                    </Breadcrumb>
                </Col>
                <Col xl={12}>
                    <CardLayout>
                        <Tabs defaultActiveKey="profile" id="mc" className="mc-tabs">
                            <Tab eventKey="profile" title="edit Profile" className="mc-tabpane profile">
                                <TabCard title="public information">
                                    <Row>
                                        <Col xl={12}>
                                            {valert}
                                            <Row>
                                                <Col xl={6}><LegendField title={ data?.name.title } value={ localStorage.getItem("title") } onChange = {(e) => setTitle(e.target.value)} /></Col>
                                                <Col xl={6}><LegendField title={ data?.username.title } value={ localStorage.getItem("user_name") } readOnly={true} /></Col>
                                            </Row>
                                        </Col>
                                    </Row>
                                </TabCard>
                                
                                <Button className="mc-btn primary" icon="verified" text={loading ?  <Spinner animation="border" /> :  "save changes" } onClick={handleSubmit1} />
                            </Tab>
                            <Tab eventKey="password" title="Change Password" className="mc-tabpane password">
                                <TabCard title="generate password">
                                    {valert}
                                    <Row>
                                        <Col xs={12} md={12}><IconField icon="lock" type="password" placeholder="current password" classes="w-100 h-lg" onChange = {(e) => setOldPassword(e.target.value)} value={oldPassword} passwordVisible /></Col>
                                        <Col xs={12} md={6}><IconField icon="add_moderator" type="password" placeholder="new password" classes="w-100 h-lg" onChange = {(e) => setPassword1(e.target.value)} value={password1} passwordVisible /></Col>
                                        <Col xs={12} md={6}><IconField icon="verified_user" type="password" placeholder="confirm password" classes="w-100 h-lg" onChange = {(e) => setPassword2(e.target.value)} value={password2} passwordVisible /></Col>
                                    </Row>
                                </TabCard>
                                <Button className="mc-btn primary" icon="verified" text={loading ?  <Spinner animation="border" /> :  "save changes" } onClick={handleSubmit2} />
                            </Tab>
                        </Tabs>
                    </CardLayout>
                </Col>
            </Row>
        </PageLayout>
    )
}